import Home from "pages/Home/HomePage";
import OrderPage from "pages/Home/OrderPage";
import { otherPages } from "./system.route";
import OrderStatus from "pages/OrderStatus/OrderStatus";
import OrderPaid from "pages/OrderStatus/OrderPaid";
import OrderComplete from "pages/OrderStatus/OrderComplete";
import ChangeProduct from "pages/Home/ChangeProduct";
import WaitingProduct from "pages/Home/WaitingProduct";
import RefundProduct from "pages/Home/RefundProduct";
import Iphone18Promax from "pages/ProductDetail/Iphone18Promax";
import Iphone18Pro from "pages/ProductDetail/Iphone18Pro";
// import IphoneDuo from "pages/ProductDetail/IphoneDuo";
import { iphone18route } from "./iphone18.route";
import IphoneDuo from "pages/ProductDetail/IphoneDuo";
import { iphoneFilterRoute } from "./iphonefilter.route";
import Watch12Gps from "pages/ProductDetail/watch12Gps";
import WatchUltra4 from "pages/ProductDetail/watchUltra4";
import Watch12Cellular from "pages/ProductDetail/watch12Cellular";

const pages = [
  ...iphone18route,
  ...iphoneFilterRoute,
  {
    path: "/preorder",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/dien-thoai-iphone-moi",
    exact: true,
    name: "Trang chủ",
    component: Home,
  },
  {
    path: "/iphone-18-pro-max",
    exact: true,
    name: "Chi tiết sản phẩm",
    component: Iphone18Promax,
  },
  {
    path: "/iphone-18-pro",
    exact: true,
    name: "Chi tiết sản phẩm",
    component: Iphone18Pro,
  },
  {
    path: "/iphone-duo",
    exact: true,
    name: "Chi tiết sản phẩm",
    component: IphoneDuo,
  },


  {
    path: "/watch-ultra-4",
    exact: true,
    name: "Chi tiết sản phẩm",
    component: WatchUltra4,
  },
  {
    path: "/watch-12-gps",
    exact: true,
    name: "Chi tiết sản phẩm",
    component: Watch12Gps,
  },
  {
    path: "/watch-12-cellular",
    exact: true,
    name: "Chi tiết sản phẩm",
    component: Watch12Cellular,
  },


  {
    path: "/order-status/:pre_order_id",
    exact: true,
    name: "Xác nhận đơn hàng",
    component: OrderStatus,
  },
  {
    path: "/order-status/paid/:pre_order_id",
    exact: true,
    name: "Thanh toán sau cọc",
    component: OrderPaid,
  },
  {
    path: "/order-status/complete/:pre_order_id",
    exact: true,
    name: "Hoàn tất đơn hàng",
    component: OrderComplete,
  },
  {
    path: "/change-product/:pre_order_id",
    exact: true,
    name: "Đổi máy",
    component: ChangeProduct,
  },
  {
    path: "/waiting-product/:pre_order_id",
    exact: true,
    name: "Lấy hàng ở đợt tiếp theo",
    component: WaitingProduct,
  },
  {
    path: "/refund/:pre_order_id",
    exact: true,
    name: "Phương án khác",
    component: RefundProduct,
  },
  {
    path: "/order/:pre_order_id",
    exact: true,
    name: "Đổi máy",
    component: OrderPage,
  },
];

const routes = [...otherPages, ...pages];

export default routes;
